import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import trans from '../../translations.json';
import ReducedData from '../../reducedData.json';
import dict from '../../dictionary';

class GenderPie extends Component {
  state = {
    genderNames: [
      trans.CasesByGender.male[this.props.lang],
      trans.CasesByGender.female[this.props.lang],
      trans.CasesByGender.other[this.props.lang],
      trans.CasesByGender.unspecified[this.props.lang],
    ],
    ready: false,
    series: [{}],
    options: {},
    totalCases: undefined,
  };

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lang !== this.props.lang) {
      this.init();
    }
  }

  init() {
    var cD = Object.values(ReducedData.dataSex);

    const reso = cD.map((item) => {
      return item[dict.resolved];
    });

    const active = cD.map((item) => {
      return item[dict.NotResolved];
    });
    const fatal = cD.map((item) => {
      return item[dict.deaths];
    });

    const total = [];
    for (let i = 0; i < fatal.length; i++) {
      total[i] = reso[i] + active[i] + fatal[i];
    }

    this.setState({
      pieData: total,
      totalCases: total.reduce((sum, item) => sum + item, 0),
      pieOptions: {
        plotOptions: {
          pie: {
            customScale: 0.6,
            expandOnClick: false,
            dataLabels: {
              offset: 80,
              minAngleToShowLabel: 10,
            },
          },
        },
        labels: this.state.genderNames,
        colors: [
          '#00b0da',
          '#ff6947',
          '#00b454',
          '#84b449',
          '#ebb14a',
        ],
        dataLabels: {
          dropShadow: {
            enabled: false,
          },
          style: {
            fontSize: '20px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'normal',
            colors: ['black'],
          },
          formatter(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name, val.toFixed(1) + '%'];
          },
        },
        legend: {
          show: false,
        },
      },
    });
    this.setState({ ready: true });
  }

  render() {
    const LegandForOtherGenders = () => (
      <div
        style={{
          margin: '40px -15px -70px',
          display: 'flex',
          fontSize: 13,
          fontFamily: 'sans-serif',
          textAlign: 'center',
          justifyContent: 'center',
        }}
      >
        {this.state.pieData.map((item, idx) => {
          if (idx !== 0 && idx !== 1)
            return (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '0px 15px',
                }}
                key={idx}
              >
                <span>{`${this.state.genderNames[idx]}`}</span>
                <span>{`${(
                  (this.state.pieData[idx] / this.state.totalCases) *
                  100
                ).toFixed(3)}%`}</span>
              </div>
            );
        })}
      </div>
    );

    return (
      this.state.ready && (
        <>
          <LegandForOtherGenders />
          <ReactApexChart
            options={this.state.pieOptions}
            series={this.state.pieData}
            type="pie"
            height="400px"
            aria-hidden="true"
          />
        </>
      )
    );
  }
}
export default GenderPie;
